import { DEAL_STAGE } from "./enums";

export const DEAL_STAGE_PROBABILITY_DEFAULTS = {
  [DEAL_STAGE.NEW_LEAD]: 10,
  [DEAL_STAGE.QUALIFICATION]: 20,
  [DEAL_STAGE.FIRST_CONTACT]: 30,
  [DEAL_STAGE.DEMO_PLANNED]: 40,
  [DEAL_STAGE.NEEDS_ANALYSIS]: 55,
  [DEAL_STAGE.OFFER_SENT]: 70,
  [DEAL_STAGE.FOLLOW_UP]: 80,
  [DEAL_STAGE.WON]: 100,
  [DEAL_STAGE.LOST]: 0,
};

export function getDefaultProbabilityForDealStage(stage) {
  return DEAL_STAGE_PROBABILITY_DEFAULTS[stage] ?? 0;
}

function parseProbabilityValue(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  const numeric = Number(raw);
  return Number.isFinite(numeric) ? numeric : null;
}

export function getInitialProbabilityForStage(stage) {
  return String(getDefaultProbabilityForDealStage(stage));
}

export function getProbabilityOnStageChange({ currentProbability, nextStage }) {
  const parsed = parseProbabilityValue(currentProbability);
  const nextDefault = getDefaultProbabilityForDealStage(nextStage);

  if (nextStage === DEAL_STAGE.WON) return "100";
  if (nextStage === DEAL_STAGE.LOST) return "0";
  if (parsed == null) return String(nextDefault);
  if (parsed < nextDefault) return String(nextDefault);
  return String(parsed);
}
